module.exports = __webpack_public_path__ + "img/Jump Casting116.7c5e6a5e.jpg";